import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { EmptyState, Page, Section } from '@marcianus/design/components';
import { ROUTES } from '@/app/routes';

// 404 do produto — EmptyState padrão + caminho de volta (nunca beco sem saída).
export function Placeholder({ title }: { title?: string; embedded?: boolean }) {
  const { t } = useTranslation('components');
  return (
    <Page>
      <EmptyState icon="globe" title={title ?? t('notFound.title')} subtitle={t('notFound.sub')} />
      <Section style={{ display: 'flex', justifyContent: 'center' }}>
        <Link to={ROUTES.attendee.explore} className="btn btn-purple btn-sm">{t('notFound.back')}</Link>
      </Section>
    </Page>
  );
}
